package com.dotdrives.web.pages.onboarding

import com.dotdrives.controller.InviteDraft
import com.dotdrives.controller.OnboardingUiState

internal data class OnboardingStepInfo(
    val title: String,
    val subtitle: String,
)

internal val onboardingSteps = listOf(
    OnboardingStepInfo("Tell us who you are", "Your profile and contact details"),
    OnboardingStepInfo("Create your organization", "Name it and choose your type"),
    OnboardingStepInfo("Invite your team", "Staff, field reps, board members"),
    OnboardingStepInfo("Add your first givers", "Import a CSV or start fresh"),
)

internal fun inviteActionLabel(invites: List<InviteDraft>): String {
    val noun = if (invites.size == 1) "teammate" else "teammates"
    return "Add ${invites.size} $noun →"
}

internal fun canSubmitInvites(state: OnboardingUiState): Boolean =
    state.canSubmitInvites

internal fun inviteInitials(email: String): String {
    val parts = email.substringBefore('@')
        .split('.', '_', '-')
        .filter { it.isNotBlank() }
    return when {
        parts.size >= 2 -> parts.take(2).joinToString("") { it.first().uppercase() }
        parts.size == 1 -> parts.first().take(2).uppercase()
        else -> "+"
    }
}
